import React from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

export function UnlinkedBottomContent() {
    const handleLinkAccounts = () => {
        sendPaymentGa({
            eventCategory: ECategoryGa.vigbo,
            action: 'button-connection-click',
        });
    };

    return (
        <Button primary onClick={handleLinkAccounts} theme="octavius" sizeMode={ButtonSizeMode.small}>
            Связать аккаунты
        </Button>
    );
}
